import React from 'react';
import unitedStatesFlag from '../../../assets/images/flag-united-states.svg';
import chinaFlag from '../../../assets/images/flag-china.svg';
import unitedKingdomFlag from '../../../assets/images/flag-united-kingdom.svg';
import franceFlag from '../../../assets/images/flag-france.svg';
import germanyFlag from '../../../assets/images/flag-germany.svg';
import indiaFlag from '../../../assets/images/flag-india.svg';
import brazilFlag from '../../../assets/images/flag-brazil.svg';
import mexicoFlag from '../../../assets/images/flag-mexico.svg';
import hongKongFlag from '../../../assets/images/flag-hong-kong.svg';
import australiaFlag from '../../../assets/images/flag-australia.svg';
import './CountryHeader.less';

interface CountryHeaderProps {
  country: string;
  countryLabel: string;
}

const COUNTRY_FLAGS: Readonly<Record<string, string>> = {
  us: unitedStatesFlag,
  cn: chinaFlag,
  gb: unitedKingdomFlag,
  uk: unitedKingdomFlag,
  fr: franceFlag,
  de: germanyFlag,
  in: indiaFlag,
  br: brazilFlag,
  mx: mexicoFlag,
  hk: hongKongFlag,
  au: australiaFlag,
};

const CountryHeader: React.FC<CountryHeaderProps> = ({ country, countryLabel }) => {
  const flag = COUNTRY_FLAGS[country.toLowerCase()];

  return (
    <div className="country-header" data-country={country}>
      {flag ? (
        <img
          className="country-header__flag"
          src={flag}
          alt={`${countryLabel}の国旗`}
        />
      ) : (
        <span
          className="country-header__flag country-header__flag--unknown"
          aria-hidden="true"
        />
      )}
      <span className="country-header__label">{countryLabel}</span>
    </div>
  );
};

export default CountryHeader;
